import gql from 'graphql-tag';
import client from '../graphqlAPI';

const GET_LOYALTY_USER_DETAIL = gql`
  query getLoyaltyUserDetail($email: String!) {
    getLoyaltyUserDetail(email: $email) {
      isAuth
      email
      name
      totalPoints
      prizes { slugName points code link createdAt claimedAt type }
      achievements { slugName points createdAt type }
    }
  }
`;

const getLoyaltyUserDetail = async ({ email }) => {
  try {
    const result = await client.query({
      query: GET_LOYALTY_USER_DETAIL, variables: { email }, errorPolicy: 'all', fetchResults: true, fetchPolicy: 'no-cache',
    }).catch((queryError) => {
      console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyUserDetail Query Error: ${queryError}`);
      return null;
    });
    return result && result.data ? result.data.getLoyaltyUserDetail : null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyUserDetail Error: ${error}`);
    return null;
  }
};

export default getLoyaltyUserDetail;
